import { AdasGlobalStyles } from '@components/wrapper-components'

export const homePageStyles = (
  <AdasGlobalStyles
    styles={{
      body: { backgroundColor: 'white' }
    }}
  />
)
